import {Action, configureStore, ThunkAction} from '@reduxjs/toolkit';
import {
  systems,
  users,
  tests,
  calendar,
  common,
  coveragePlans,
  profile,
  compare,
} from './slices';

export const makeStore = () =>
  configureStore({
    reducer: {
      systems,
      users,
      tests,
      calendar,
      common,
      coveragePlans,
      profile,
      compare,
    },
    middleware: getDefaultMiddleware => {
      const middlewares = getDefaultMiddleware();
      if (process.env.NATS_ENV === 'dev') {
        // middlewares.push(logger as any);
      }
      return middlewares;
    },
  });

const store = makeStore();

export {store};
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
